import React, { useMemo, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import { useTranslation } from 'react-i18next';
import ActionAIModelSettings from './ActionAIModelSettings';
import {
  useActionAIModels,
  useActionType,
} from './ActionScopeContext';
import { getActionAIModelTypes } from '../../Utils/actionAIModelUtils';

const ActionAIModelDialog = ({ primaryColor = '#5757b0', onSave }) => {
  const { t } = useTranslation();
  const actionType = useActionType();
  const { isPluginAction } = useActionAIModels();
  const [open, setOpen] = useState(false);
  const modelTypes = useMemo(
    () => getActionAIModelTypes(actionType, isPluginAction),
    [actionType, isPluginAction]
  );

  if (modelTypes.length === 0) {
    return null;
  }

  const label = t('global_setting.model_settings_section', 'AI model settings');

  return (
    <>
      <Tooltip title={label}>
        <IconButton
          onClick={() => setOpen(true)}
          aria-label={label}
          data-testid="action-ai-model-settings-button"
          sx={{
            color: primaryColor,
            mr: 0.5,
            '&:hover': {
              backgroundColor: `${primaryColor}10`,
            },
          }}
        >
          <TuneIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        data-testid="action-ai-model-settings-dialog"
      >
        <DialogTitle>{label}</DialogTitle>
        <DialogContent dividers>
          <ActionAIModelSettings asGridItem={false} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>
            {t('action_common.cancel', 'Close')}
          </Button>
          {typeof onSave === 'function' && (
            <Button
              variant="contained"
              onClick={() => {
                onSave();
                setOpen(false);
              }}
              data-testid="action-ai-model-save-button"
            >
              {t('action_common.save_settings', 'Save Settings')}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActionAIModelDialog;
